export interface IMortalityRecipient {
    age: number,
    type: string,
    alias: string,
    bloodType: string,
    centerId: number,
    declineRatio: string,
    declineRatioCurrent: string,
    declineRatioHistoric: string,
    highestDeclineRatio: string,
    dialysisMonths: number,
    id: number,
    oneYearMortalityRisk: string,
    predictedOneYearSurvivalRate: string,
    applicableWaitTime: string,
    reviewableDonors: number,
    forecastedWaitTime: string,
    roundedCpra4: string
}